import { Text } from '$components'
import { LinkButton } from '$components'
import { Tooltip } from '$components'
import { SmileIcon, PlusIcon } from '$components'
import { ClientRoutePath } from '../routes/protected'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export type NoClientsEmptyStateProps = {
  isNoResults: boolean
}

export function NoClientsEmptyState({ isNoResults = false }: NoClientsEmptyStateProps) {
  const { hasSubscriptionExpired } = useTenant()

  return (
    <div className="w-full h-fit p-stack-hero bg-surface-muted rounded-card flex flex-col items-center justify-center text-center">
      <SmileIcon className="size-12 text-fg-link mb-stack-roomy" />

      <Text
        type="h3"
        className="mb-stack-roomy text-fg"
      >
        {!isNoResults ? 'No clients created yet' : 'No clients found'}
      </Text>

      <Text
        type="s"
        className="text-fg-subtle max-w-prose-md mb-stack-section"
      >
        {!isNoResults
          ? 'Clients are the pet owners who book appointments with you. Add your first client to start managing their pets and booking appointments.'
          : 'No clients found matching your search. Try adjusting your search criteria or create a new client.'
        }
      </Text>

      {isNoResults && (
        <Tooltip
          content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
          disabled={!hasSubscriptionExpired}
        >
          <LinkButton
            to={ClientRoutePath.ClientsCreate}
            icon={PlusIcon}
            disabled={hasSubscriptionExpired}
          >
            New Client
          </LinkButton>
        </Tooltip>
      )}
    </div>
  )
}
